import { MONTHS_LIST } from './consts';

export const fillWeek = () => {
  const result = [{}, {}, {}, {}, {}, {}, {}];
  return result;
};

export const getPrevMonth = (month: number) => {
  let curr = month - 1;
  if (curr < 1) curr = 12;
  return MONTHS_LIST[curr - 1];
};

export const getNextMonth = (month: number) => {
  let curr = month + 1;
  if (curr > 12) curr = 1;
  return MONTHS_LIST[curr - 1];
};



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/calendar/components/calendar/components/month/tools.ts